import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationServices } from 'modules/accommodations/features/reservations/api';
import { useCurrenciesQuery, useUnitOfMeasuresQuery } from 'modules/root';

export const useCalculationServiceTypesQuery = (params?: any) => {
  const {
    isLoading: isLoadingServiceTypes,
    isError: isErrorServiceTypes,
    data: serviceTypes,
  } = useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_SERVICE_TYPE, params],
    () => getCalculationServices(params),
    getCacheSettings(),
  );

  const {
    isLoading: isLoadingCurrencies,
    isError: isErrorCurrencies,
    currencies,
  } = useCurrenciesQuery();

  const {
    isLoading: isLoadingUnitOfMeasures,
    isError: isErrorUnitOfMeasuresQuery,
    unitOfMeasures,
  } = useUnitOfMeasuresQuery();

  return {
    isLoading: isLoadingServiceTypes || isLoadingCurrencies || isLoadingUnitOfMeasures,
    isError: isErrorServiceTypes || isErrorCurrencies || isErrorUnitOfMeasuresQuery,
    serviceTypes: serviceTypes ?? [],
    currencies,
    unitOfMeasures,
  };
};
